/* eslint-disable no-console */

// Proxied base (setupProxy rewrites /kc -> https://develop.intern.c64.ai/auth)
const KC_BASE = "/kc";
const KC_REALM = "dch-alpha";
const KC_CLIENT_ID = "dch-dch";

// ⚠️ Demo-only: hardcoded creds (move server-side for prod)
const USERNAME = "dch-admin";
const PASSWORD = "ionio5n32n5asfdasd";

/**
 * Direct Grant login → returns:
 * { access_token, refresh_token, expires_in, refresh_expires_in, token_type, ... }
 */
export async function getTokens() {
  // Use proxy in development to avoid CORS issues
  const url = `${KC_BASE}/realms/${KC_REALM}/protocol/openid-connect/token`;
  // For production/kubernetes, use direct URL:
  // const url = `https://dch-india.experimental.context64.ai/auth/realms/${KC_REALM}/protocol/openid-connect/token`;

  console.log('🔐 DEBUG: Keycloak auth URL:', url);
  console.log('🔐 DEBUG: Realm:', KC_REALM, 'Client:', KC_CLIENT_ID, 'User:', USERNAME);

  const r = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      client_id: KC_CLIENT_ID,
      grant_type: "password",
      username: USERNAME,
      password: PASSWORD,
    }),
  });

  console.log('🔐 DEBUG: Keycloak response status:', r.status, r.statusText);

  if (!r.ok) {
    const text = await r.text().catch(() => "");
    console.error('❌ DEBUG: Keycloak error:', text);
    throw new Error(`Keycloak login failed: ${r.status} ${r.statusText}${text ? " - " + text : ""}`);
  }

  const tokens = await r.json();
  console.log('🔐 DEBUG: Successfully got tokens');
  return tokens;
}